<template>
    <!DOCTYPE html><html>
      <head></head>
        <body style="font-family: 'Montserrat', sans-serif; color: #000000 !important;">
          <pre style="padding-bottom: 8px; font-family: 'Montserrat', sans-serif; font-size: 40px; font-weight:900; text-align: center; text-transform: uppercase;">Comprobante Canje</pre>
          <table  style="border-collapse: collapse;  width: 100%; font-size: 22px;">  
            <tr>    
              <td style="padding: 2px; font-weight:600;">Boleto:</td>
              <td style="padding: 2px; padding-bottom: 4px; text-transform: uppercase; font-weight:800;">{{boleto.id}}</td>  
            </tr>    
            <tr>    
              <td style="padding: 2px; font-weight:600;">Fecha:</td>
              <td style="padding: 2px; padding-bottom: 4px; text-transform: uppercase; font-weight:800;">{{ Date.now() | moment('DD-MM-YYYY HH:mm:ss')}}</td>   
            </tr>  
            <tr>    
              <td style="padding: 2px; font-weight:600;">Vendedor:</td>
              <td style="padding: 2px; padding-bottom: 4px; text-transform: uppercase; font-weight:800;">{{user.username}}</td> 
            </tr> 
            <tr>    
              <td style="padding: 2px; font-weight:600;">Importe:</td>
              <td style="padding: 2px; padding-bottom: 4px; text-transform: uppercase; font-weight:800;">{{importe}}</td> 
            </tr> 
            <tr>    
                <td style="padding: 2px; font-weight:600;"></td> 
                <td style="padding: 2px; padding-bottom: 4px; text-transform: uppercase; font-weight:800;">{{boleto.resumen_pago}}</td> 
            </tr> 
          </table>
        </body>
      </html>
</template>
<script>
export default {
  props: {
    boleto: {required: false},
    user: {required: false},
    importe: {required: false},
  },

  data() {
      return {
      
      };
    },

  mounted(){
    //const date = new Date();
    //this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
  },
}
</script>
<style scoped> 
</style>